import React, {useState} from "react";
import { Link } from "react-router-dom";

function Projects() {
  const [columnWidth, setColumnWidth] = useState(null);


  return (
    <div>
      <section className="projects pt-4 pb-3 mt-3" style={{backgroundColor: '#F3F6FB'}}>
        <div className="container">
              <div className="section-header mt-2 mb-5 text-center" >
                <h6>Work Of Excellence</h6>
                <h2>Explore Our Previous Projects</h2>
              </div>
        <div class="row my-row">
          <div class={`col-md-${columnWidth===1 ? '6' : '3'}  my-column-1 logo-work`}  onMouseOver={() => setColumnWidth (1)}
          onMouseLeave={() => setColumnWidth (null)}>
            <div class="content-overlay">
                <h2>Logo Designs</h2>
               <Link to='/our-work'> <button className="second-button">View All</button></Link>
            </div>
          </div>
          <div class={`col-md-${columnWidth===1 || columnWidth === 3 ? '3' : '6'}  my-column-1 give-aways`} >
          <div class="content-overlay">
                <h2>Give Aways</h2>
                <Link to='/our-work'> <button className="second-button">View All</button></Link>
            </div>
          </div>
          <div class={`col-md-${columnWidth===3 ? '6' : '3'}  my-column-1 packaging`}  onMouseOver={() => setColumnWidth (3)}
          onMouseLeave={() => setColumnWidth (null)} >
            <div class="content-overlay">
                <h2>Packaging Designs</h2>
                <Link to='/our-work'> <button className="second-button">View All</button></Link>
            </div>
          </div>
          {/* <div class={`col-md-${columnWidth===3 ? '4' : '4'}  my-column-1 cafe`}  onMouseOver={() => setColumnWidth (3)}
          onMouseLeave={() => setColumnWidth (null)}>
          <div class="content-overlay">
                <h2>Restaurants Menus</h2>
                <Link to='/our-work'> <button className="second-button">View All</button></Link>
            </div>
          </div> */}
        </div>
        </div>
      </section>
    </div>
  );
}

export default Projects;
